import React from 'react';
import image8 from '../../../../../images/modules/module-1/8.png';
import image9 from '../../../../../images/modules/module-1/9.png';
import image10 from '../../../../../images/modules/module-1/10.png';
import './index.scss';

export const Divider = () => {
    return (
        <div className='revue-divider'>
            <div className='revue-divider-item'>
                <img className='revue-divider-item__image' src={image8} alt='cover' />
                <div className='revue-divider-item__content'>
                    <div className='revue-divider-item__category'>Music</div>
                    <div className='revue-divider-item__title'>
                        5 Key Takeaways From Chappell Roan’s Guest Appearance on Call Her Daddy
                    </div>
                </div>
            </div>

            <div className='revue-divider-item'>
                <img className='revue-divider-item__image' src={image9} alt='cover' />
                <div className='revue-divider-item__content'>
                    <div className='revue-divider-item__category'>Celebrity Style</div>
                    <div className='revue-divider-item__title'>
                        32 Celebrity Vintage Fashion Moments That Live In My Mind Rent-Free
                    </div>
                </div>
            </div>

            <div className='revue-divider-item'>
                <img className='revue-divider-item__image' src={image10} alt='cover' />
                <div className='revue-divider-item__content'>
                    <div className='revue-divider-item__category'>Fashion</div>
                    <div className='revue-divider-item__title'>
                        ’60s Super Penelope Tree Recalls Witnessing The Birth Of Boho Style
                    </div>
                </div>
            </div>
        </div>
    );
};
